import { render, staticRenderFns } from "./WalletValues.vue?vue&type=template&id=180e290a&"
import script from "./WalletValues.vue?vue&type=script&lang=js&"
export * from "./WalletValues.vue?vue&type=script&lang=js&"
import style0 from "./WalletValues.vue?vue&type=style&index=0&id=180e290a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports